import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import {withRouter} from "react-router";
import NPIf from "np-if";
import NPElse from "np-if/src/NPElse";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";

/**
 * Display the discounts applied to order
 *
 * @author América Mendoza  <amendoza@nodeport.co>
 * @author Darién Miranda <dmiranda@nodeport.co>
 * @author Oscar Peña <opena@nodeport.co>
 */


class OrderParcels extends React.Component {
    render() {
        const columns = [
            {
                dataField: 'parcelName',
                text: 'Paquetería',
                formatter:(v,row) =>{
                    return(
                        <div>
                            {v}
                        </div>
                    )
                }
            },
            {
                dataField: 'parcelNumber',
                text: 'Número de guía',
                formatter:(v,row) =>{
                    return(
                        <div>
                            {v}
                        </div>
                    )
                }
            },
            {
                dataField: 'status',
                text: 'Estado',
                formatter:(v,row) =>{
                    let status = "";
                    switch (v){
                        case 'Created':
                            status = "Creado"
                            break;
                        case 'Shipped':
                            status = "Enviado"
                            break;
                        case 'Delivered':
                            status = "Entregado"
                            break;
                        case 'Canceled':
                            status = "Cancelado"
                            break;
                        case 'Information':
                            status = "En espera información"
                            break;
                        case 'N/A':
                            status = "No disponible"
                            break;
                        case 'Pending':
                            status = "Pendiente"
                            break;
                        case 'Picked Up':
                            status = "Recolectado"
                            break;
                        case 'Out for Delivery':
                            status = "En ruta de entrega"
                            break;
                        case 'Lost':
                            status = "Perdido"
                            break;
                        case 'Returned':
                            status = "Devuelto"
                            break;
                        case 'Pickup at Office':
                            status = "Recoger en oficina"
                            break;
                        case 'Delivered at Origin':
                            status = "Devuelto a oficinas"
                            break;
                        case 'Damaged':
                            status = "Dañado"
                            break;
                        case 'Redirected':
                            status = "Enviando a nuevo domicilio"
                            break;
                        case 'Out for Pickup':
                            status = "Listo para recolección"
                            break;
                        case '1 delivery attempt':
                            status = "Primer intento de entrega"
                            break;
                        case '2 delivery attempts':
                            status = "Segundo intento de entrega"
                            break;
                        case '3 delivery attempts':
                            status = "Tercer intento de entrega"
                            break;
                        case 'Return problem':
                            status = "Problema con la devolución"
                            break;
                        case 'Address error':
                            status = "Error en el domicilio"
                            break;
                        case 'Undeliverable':
                            status = "No entregado al cliente"
                            break;
                        case 'Delayed':
                            status = "Retrasado"
                            break;
                        case 'Rejected':
                            status = "Rechazado por el cliente"
                            break;
                        case '1 pickup attempt':
                            status = "Primer  intento de recolección"
                            break;
                        case 'Partially Shipped':
                            status = "Envío parcial"
                            break;
                        case 'Partially Delivered':
                            status = "Entrega parcial"
                            break;
                        case 'Delivery Attempt':
                            status = "Intento de entrega"
                            break;
                        default:
                            break;
                    }
                    return(
                        <div>
                            {status}
                        </div>
                    )
                }
            },
            {
                dataField: 'parcelTrackingLink',
                text: 'Enlace para tracking',
                formatter:(v,row) =>{
                    return(
                        <a href={v} target={'_blank'}>
                            {v}
                        </a>
                    )
                }
            },
            {
                dataField: 'parcelLabel',
                text: 'Etiqueta',
                formatter:(v,row) =>{
                    return(
                        <a href={v} target={'_blank'}>
                            {v}
                        </a>
                    )
                }
            },

        ];
        return (
            <Col>
                <NPIf condition={this.props.isLoading}>
                    <Spinner animation={'grow'} variant={'primary'}>
                    </Spinner>
                    <NPElse>
                        <BootstrapTable keyField='_id'
                                        data={this.props.parcels}
                                        columns={columns}
                                        noDataIndication={`No se han agregado números de guía`}
                                        bordered={false}/>
                    </NPElse>
                </NPIf>
            </Col>
        )
    }
}
export default withRouter(OrderParcels);
OrderParcels.propTypes    = {
    parcels: PropTypes.array,
    isLoading: PropTypes.bool
}
OrderParcels.defaultProps = {
    parcels: [],
    isLoading: false
}

